<template>
  <div
    class="bets-container">
    <div class="bets-tabs">
      <div
        v-bind:class="[{'bets-tabs-active':activeBetSection === 'betslip'},{'bet-tab--disabled':isPlacingBets}]"
        class="bets-tab"
        @click="selectBetsSection('betslip')">
        <div class="bets-text">
          <span>{{ $t('bets.betslip')}}</span>
        </div>
        <div class="bets-indicator bets-tab-count" v-if="betslipBets.length > 0">
          <span>{{betslipBets.length}}</span>
        </div>
        <div class="bets-tab-bottom-bar">
        </div>
      </div>
      <div
        v-bind:class="[{'bets-tabs-active':activeBetSection === 'activeBets'},{'bet-tab--disabled':isPlacingBets}]"
        class="bets-tab"
        @click="selectBetsSection('activeBets')">
        <div class="bets-text">
          <span>{{ $t('bets.open')}}</span>
        </div>
        <div class="bets-umatched-indicator bets-tab-count" v-if="openBetsUnmatched > 0">
          <span>{{openBetsUnmatched}}</span>
        </div>
        <div class="bets-tab-bottom-bar">
        </div>
      </div>
      <div
        v-bind:class="[{'bets-tabs-active':activeBetSection === 'settled'},{'bet-tab--disabled':isPlacingBets}]"
        class="bets-tab"
        @click="selectBetsSection('settled')">
        <div class="bets-text">
          <span>{{ $t('bets.settled')}}</span>
        </div>

        <div class="bets-tab-bottom-bar">
        </div>
      </div>
    </div>
    <transition name="slide">
      <div v-if="betslipMessage.message !=''" class="bets-top-alert" v-bind:class="[{
      'error-message':betslipMessage.type==='error',
      'success-message':betslipMessage.type==='success',
      'warning-message':betslipMessage.type==='warning',
      }]">
        <span>{{betslipMessage.message}}</span>
      </div>
    </transition>
    <div id="bets-container">
      <BetSlip v-if="activeBetSection === 'betslip'"></BetSlip>
      <OpenBets v-if="activeBetSection === 'activeBets'"></OpenBets>
      <SettledBets v-if="activeBetSection === 'settled'"></SettledBets>
    </div>
  </div>
</template>

<script>

import BetSlip from '@/components/views/BetSlip';
import KryptButton from "@/components/other/kryptButton";
import OpenBets from "@/components/views/OpenBets";
import SettledBets from "@/components/views/SettledBets";

export default {
  name: "Bets",
  data() {
    return{
      betsTabs:[
        'betslip',
        'activeBets',
        'settled'
      ],
      activeTab:'betslip',
      activePanels: [0]
    }
  },
  computed:{
    betslipBets:function(){
      return this.$store.state.bets.betslip.backBets.concat(this.$store.state.bets.betslip.layBets)
    },
    openBetsUnmatched: function () {
      let unmatched = 0
      let groupWithUnmatched = Object.values(JSON.parse(JSON.stringify(this.$store.state.bets.active.openBets)))
        .map(function (eventGroup) {
          let filteredEventGroup = eventGroup;
          filteredEventGroup.bets.lay = filteredEventGroup.bets.lay.filter(function (bet) {
            if (bet.betStatus === 'Unmatched') {
              return true;
            } else {
              return false;
            }
          }.bind(this));
          filteredEventGroup.bets.back = filteredEventGroup.bets.back.filter(function (bet) {
            if (bet.betStatus === 'Unmatched') {
              return true;
            } else {
              return false;
            }
          }.bind(this));
          return (filteredEventGroup.bets.back.length + filteredEventGroup.bets.lay.length > 0 ? filteredEventGroup : false);
        }.bind(this)).filter(function (group) {
          return group
        });
      groupWithUnmatched.forEach((group)=>{
        unmatched+=group.bets.lay.length;
        unmatched+=group.bets.back.length;
      });


      return unmatched
    },
    isPlacingBets:function(){
      return this.$store.state.bets.betslip.isPlacingBets;
    },
    activeBetSection:function () {
      return this.$store.state.bets.activeSection;
    },
    betslipMessage:function () {
      return this.$store.state.bets.betslip.message;
    }
  },
  methods:{
    selectBetsSection:function(section){
      if(!this.isPlacingBets) this.$store.commit('setActiveBetSection',section)
    }
  },
  components:{
    OpenBets,
    KryptButton,
    BetSlip,
    SettledBets
  }
}
</script>

<style scoped>

.bets-container{
  width: 360px;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  z-index: 0;
}

#bets-container{
  overflow: auto;
  display: flex;
  flex-grow: 1;
  width: 100%;
  position: relative;
  overscroll-behavior: contain;
}

.bets-tabs{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100% ;
  cursor: pointer;
  background-color: var(--grey-100);
  min-height: 48px;
}

.bets-tabs-active{
  background-color: white !important;
}

.bets-tab{
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 48px; /* can't avoid hard-coding height because indicator is not always there and text might wrap */
  padding: 8px; /* so that nothing hits the edges */
  overflow: hidden;
}

.bets-text{
  /* padding-top: 15px; - removing because it increases height when the header text wraps */
  /* padding-right: 4px; - removing because it doesn't allow proper centre alignment */
  /* padding-bottom: 17px; - removing because it increases height when the header text wraps */
  max-height: 32px;
  overflow: hidden;
}

.bets-text > span{
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  line-height: 16px;
  font-size: 12px;
  font-weight: 700;
  color: var(--grey-400);
  user-select: none;
  width: min-content;
}

.bets-tab:not(.bets-tabs-active):hover .bets-text > span {
  color: var(--grey-600);
}

.bets-tabs-active .bets-text > span{
  color: var(--grey-900) !important;
}

.bets-umatched-indicator{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--cyborg);
  border-radius: 16px;
}
.bets-indicator{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--primary);
  border-radius: 16px;
}
.bets-tabs-active .bets-tab-count{
  /*background-color: var(--primary);*/
}

.bets-tab-count > span{
  display: flex;
  align-items: center;
  text-align: center;
  user-select: none;
  line-height: 14px;
  color: white;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 4px;
}

.bets-tab-count {
  min-width: 20px;
  margin-left: 4px;
}

.bets-tab-bottom-bar{
  display: flex;
  position: absolute;
  width: 100%;
  border-radius: 17px;
  background-color: transparent;
  padding: 2px 0;
  bottom: 0;
}


.bets-tabs-active .bets-tab-bottom-bar{
  background-color: var(--primary) !important;
}

.bets-top-alert{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  max-height: 73px;
  clip-path: inset(0%);
  transition: max-height 0.5s ease-in-out;
}

.bets-top-alert > span{
  padding: 8px 8px;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  height: max-content;
  text-align: center;
  /*color: var(--cyborg);*/
}
.error-message > span{

  background-color: var(--cyborg-light);
  color: var(--cyborg);
}
.success-message > span{
  background-color:var(--aquaman-light);
  color: var(--aquaman);
}
.warning-message > span{
  background-color: var(--wonder-woman-light);

  color: var(--wonder-woman);
}
.slide-enter-active, .slide-leave-active {
  transition: max-height 0.5s ease-in-out;
}

.slide-enter, .slide-leave-to {
  max-height: 0px;
}
.bet-tab--disabled{
  /*opacity: 0.6;*/
  cursor: not-allowed;
}
/*Media Queries*/

@media screen and (max-width: 1279px) {
  .bets-container{
    width: 100%!important;
  }
}

</style>
